/* istanbul ignore next */
export class ErrorModalConfig {
  public errorTitle: string;
  public errorDescription: string;
  public errorCloseText: string;
}
